export const currencies = [
  {
    name: 'US Dollar',
    code: 'USD',
    symbol: '$',
  },
  {
    name: 'Canadian Dollar',
    code: 'CAD',
    symbol: 'CA$',
  },
  {
    name: 'Euro',
    code: 'EUR',
    symbol: '€',
  },
  {
    name: 'United Arab Emirates Dirham',
    code: 'AED',
    symbol: 'د.إ',
  },
  {
    name: 'Afghan Afghani',
    code: 'AFN',
    symbol: '؋',
  },
  {
    name: 'Albanian Lek',
    code: 'ALL',
    symbol: 'L',
  },
  {
    name: 'Armenian Dram',
    code: 'AMD',
    symbol: '֏',
  },
  {
    name: 'Argentine Peso',
    code: 'ARS',
    symbol: '$',
  },
  {
    name: 'Australian Dollar',
    code: 'AUD',
    symbol: 'A$',
  },
  {
    name: 'Azerbaijani Manat',
    code: 'AZN',
    symbol: '₼',
  },
  {
    name: 'Bahamian Dollar',
    code: 'BSD',
    symbol: 'B$',
  },
  {
    name: 'Bosnia-Herzegovina Convertible Mark',
    code: 'BAM',
    symbol: 'KM',
  },
  {
    name: 'Bangladeshi Taka',
    code: 'BDT',
    symbol: '৳',
  },
  {
    name: 'Bulgarian Lev',
    code: 'BGN',
    symbol: 'лв',
  },
  {
    name: 'Bahraini Dinar',
    code: 'BHD',
    symbol: '.د.ب',
  },
  {
    name: 'Burundian Franc',
    code: 'BIF',
    symbol: 'FBu',
  },
  {
    name: 'Brunei Dollar',
    code: 'BND',
    symbol: 'B$',
  },
  {
    name: 'Bolivian Boliviano',
    code: 'BOB',
    symbol: 'Bs.',
  },
  {
    name: 'Brazilian Real',
    code: 'BRL',
    symbol: 'R$',
  },
  {
    name: 'Botswanan Pula',
    code: 'BWP',
    symbol: 'P',
  },
  {
    name: 'Belarusian Ruble',
    code: 'BYN',
    symbol: 'Br',
  },
  {
    name: 'Belize Dollar',
    code: 'BZD',
    symbol: 'BZ$',
  },
  {
    name: 'Congolese Franc',
    code: 'CDF',
    symbol: 'FC',
  },
  {
    name: 'Swiss Franc',
    code: 'CHF',
    symbol: 'CHF',
  },
  {
    name: 'Chilean Peso',
    code: 'CLP',
    symbol: '$',
  },
  {
    name: 'Chinese Yuan',
    code: 'CNY',
    symbol: '¥',
  },
  {
    name: 'Colombian Peso',
    code: 'COP',
    symbol: '$',
  },
  {
    name: 'Costa Rican Colón',
    code: 'CRC',
    symbol: '₡',
  },
  {
    name: 'Cape Verdean Escudo',
    code: 'CVE',
    symbol: '$',
  },
  {
    name: 'Czech Republic Koruna',
    code: 'CZK',
    symbol: 'Kč',
  },
  {
    name: 'Djiboutian Franc',
    code: 'DJF',
    symbol: 'Fdj',
  },
  {
    name: 'Danish Krone',
    code: 'DKK',
    symbol: 'kr',
  },
  {
    name: 'Dominican Peso',
    code: 'DOP',
    symbol: 'RD$',
  },
  {
    name: 'Algerian Dinar',
    code: 'DZD',
    symbol: 'د.ج',
  },
  {
    name: 'Estonian Kroon',
    code: 'EEK',
    symbol: 'kr',
  },
  {
    name: 'Egyptian Pound',
    code: 'EGP',
    symbol: 'E£',
  },
  {
    name: 'Eritrean Nakfa',
    code: 'ERN',
    symbol: 'Nfk',
  },
  {
    name: 'Ethiopian Birr',
    code: 'ETB',
    symbol: 'Br',
  },
  {
    name: 'British Pound Sterling',
    code: 'GBP',
    symbol: '£',
  },
  {
    name: 'Georgian Lari',
    code: 'GEL',
    symbol: '₾',
  },
  {
    name: 'Ghanaian Cedi',
    code: 'GHS',
    symbol: '₵',
  },
  {
    name: 'Guinean Franc',
    code: 'GNF',
    symbol: 'FG',
  },
  {
    name: 'Guatemalan Quetzal',
    code: 'GTQ',
    symbol: 'Q',
  },
  {
    name: 'Hong Kong Dollar',
    code: 'HKD',
    symbol: 'HK$',
  },
  {
    name: 'Honduran Lempira',
    code: 'HNL',
    symbol: 'L',
  },
  {
    name: 'Croatian Kuna',
    code: 'HRK',
    symbol: 'kn',
  },
  {
    name: 'Hungarian Forint',
    code: 'HUF',
    symbol: 'Ft',
  },
  {
    name: 'Indonesian Rupiah',
    code: 'IDR',
    symbol: 'Rp',
  },
  {
    name: 'Israeli New Sheqel',
    code: 'ILS',
    symbol: '₪',
  },
  {
    name: 'Indian Rupee',
    code: 'INR',
    symbol: '₹',
  },
  {
    name: 'Iraqi Dinar',
    code: 'IQD',
    symbol: 'ع.د',
  },
  {
    name: 'Iranian Rial',
    code: 'IRR',
    symbol: '﷼',
  },
  {
    name: 'Icelandic Króna',
    code: 'ISK',
    symbol: 'kr',
  },
  {
    name: 'Jamaican Dollar',
    code: 'JMD',
    symbol: 'J$',
  },
  {
    name: 'Jordanian Dinar',
    code: 'JOD',
    symbol: 'د.ا',
  },
  {
    name: 'Japanese Yen',
    code: 'JPY',
    symbol: '¥',
  },
  {
    name: 'Kenyan Shilling',
    code: 'KES',
    symbol: 'KSh',
  },
  {
    name: 'Cambodian Riel',
    code: 'KHR',
    symbol: '៛',
  },
  {
    name: 'Comorian Franc',
    code: 'KMF',
    symbol: 'CF',
  },
  {
    name: 'South Korean Won',
    code: 'KRW',
    symbol: '₩',
  },
  {
    name: 'Kuwaiti Dinar',
    code: 'KWD',
    symbol: 'د.ك',
  },
  {
    name: 'Kazakhstani Tenge',
    code: 'KZT',
    symbol: '₸',
  },
  {
    name: 'Lebanese Pound',
    code: 'LBP',
    symbol: 'ل.ل',
  },
  {
    name: 'Sri Lankan Rupee',
    code: 'LKR',
    symbol: '₨',
  },
  {
    name: 'Lithuanian Litas',
    code: 'LTL',
    symbol: 'Lt',
  },
  {
    name: 'Latvian Lats',
    code: 'LVL',
    symbol: 'Ls',
  },
  {
    name: 'Libyan Dinar',
    code: 'LYD',
    symbol: 'ل.د',
  },
  {
    name: 'Maldivian Rufiyaa',
    code: 'MVR',
    symbol: 'MVR',
  },
  {
    name: 'Moroccan Dirham',
    code: 'MAD',
    symbol: 'د.م.',
  },
  {
    name: 'Moldovan Leu',
    code: 'MDL',
    symbol: 'L',
  },
  {
    name: 'Malagasy Ariary',
    code: 'MGA',
    symbol: 'Ar',
  },
  {
    name: 'Macedonian Denar',
    code: 'MKD',
    symbol: 'ден',
  },
  {
    name: 'Myanma Kyat',
    code: 'MMK',
    symbol: 'K',
  },
  {
    name: 'Macanese Pataca',
    code: 'MOP',
    symbol: 'MOP$',
  },
  {
    name: 'Mauritian Rupee',
    code: 'MUR',
    symbol: '₨',
  },
  {
    name: 'Mexican Peso',
    code: 'MXN',
    symbol: '$',
  },
  {
    name: 'Malaysian Ringgit',
    code: 'MYR',
    symbol: 'RM',
  },
  {
    name: 'Mozambican Metical',
    code: 'MZN',
    symbol: 'MT',
  },
  {
    name: 'Namibian Dollar',
    code: 'NAD',
    symbol: 'N$',
  },
  {
    name: 'Nigerian Naira',
    code: 'NGN',
    symbol: '₦',
  },
  {
    name: 'Nicaraguan Córdoba',
    code: 'NIO',
    symbol: 'C$',
  },
  {
    name: 'Norwegian Krone',
    code: 'NOK',
    symbol: 'kr',
  },
  {
    name: 'Nepalese Rupee',
    code: 'NPR',
    symbol: '₨',
  },
  {
    name: 'New Zealand Dollar',
    code: 'NZD',
    symbol: 'NZ$',
  },
  {
    name: 'Omani Rial',
    code: 'OMR',
    symbol: 'ر.ع.',
  },
  {
    name: 'Panamanian Balboa',
    code: 'PAB',
    symbol: 'B/.',
  },
  {
    name: 'Peruvian Nuevo Sol',
    code: 'PEN',
    symbol: 'S/.',
  },
  {
    name: 'Philippine Peso',
    code: 'PHP',
    symbol: '₱',
  },
  {
    name: 'Pakistani Rupee',
    code: 'PKR',
    symbol: '₨',
  },
  {
    name: 'Polish Zloty',
    code: 'PLN',
    symbol: 'zł',
  },
  {
    name: 'Paraguayan Guarani',
    code: 'PYG',
    symbol: '₲',
  },
  {
    name: 'Qatari Rial',
    code: 'QAR',
    symbol: 'ر.ق',
  },
  {
    name: 'Romanian Leu',
    code: 'RON',
    symbol: 'lei',
  },
  {
    name: 'Serbian Dinar',
    code: 'RSD',
    symbol: 'дин.',
  },
  {
    name: 'Russian Ruble',
    code: 'RUB',
    symbol: '₽',
  },
  {
    name: 'Rwandan Franc',
    code: 'RWF',
    symbol: 'RF',
  },
  {
    name: 'Saudi Riyal',
    code: 'SAR',
    symbol: 'ر.س',
  },
  {
    name: 'Seychellois Rupee',
    code: 'SCR',
    symbol: 'SCR',
  },
  {
    name: 'Sudanese Pound',
    code: 'SDG',
    symbol: 'ج.س.',
  },
  {
    name: 'Swedish Krona',
    code: 'SEK',
    symbol: 'kr',
  },
  {
    name: 'Singapore Dollar',
    code: 'SGD',
    symbol: 'S$',
  },
  {
    name: 'Somali Shilling',
    code: 'SOS',
    symbol: 'S',
  },
  {
    name: 'Syrian Pound',
    code: 'SYP',
    symbol: '£',
  },
  {
    name: 'Thai Baht',
    code: 'THB',
    symbol: '฿',
  },
  {
    name: 'Tunisian Dinar',
    code: 'TND',
    symbol: 'د.ت',
  },
  {
    name: 'Tongan Paʻanga',
    code: 'TOP',
    symbol: 'T$',
  },
  {
    name: 'Turkish Lira',
    code: 'TRY',
    symbol: '₺',
  },
  {
    name: 'Trinidad and Tobago Dollar',
    code: 'TTD',
    symbol: 'TT$',
  },
  {
    name: 'New Taiwan Dollar',
    code: 'TWD',
    symbol: 'NT$',
  },
  {
    name: 'Tanzanian Shilling',
    code: 'TZS',
    symbol: 'TSh',
  },
  {
    name: 'Ukrainian Hryvnia',
    code: 'UAH',
    symbol: '₴',
  },
  {
    name: 'Ugandan Shilling',
    code: 'UGX',
    symbol: 'USh',
  },
  {
    name: 'Uruguayan Peso',
    code: 'UYU',
    symbol: '$U',
  },
  {
    name: 'Uzbekistan Som',
    code: 'UZS',
    symbol: 'лв',
  },
  {
    name: 'Venezuelan Bolívar',
    code: 'VEF',
    symbol: 'Bs.F',
  },
  {
    name: 'Vietnamese Dong',
    code: 'VND',
    symbol: '₫',
  },
  {
    name: 'CFA Franc BEAC',
    code: 'XAF',
    symbol: 'FCFA',
  },
  {
    name: 'CFA Franc BCEAO',
    code: 'XOF',
    symbol: 'CFA',
  },
  {
    name: 'Yemeni Rial',
    code: 'YER',
    symbol: '﷼',
  },
  {
    name: 'South African Rand',
    code: 'ZAR',
    symbol: 'R',
  },
  {
    name: 'Zambian Kwacha',
    code: 'ZMK',
    symbol: 'ZK',
  },
  {
    name: 'Zimbabwean Dollar',
    code: 'ZWL',
    symbol: 'Z$',
  },
];
